// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-screen-container {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);
  font-family: 'Arial', sans-serif;
}

.forgot-password-screen-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

.forgot-password-screen-card {
  position: relative;
  width: min(520px, 94vw);
  background: rgba(22, 22, 22, 0.95);
  border: 1px solid rgba(196, 222, 29, 0.35);
  border-radius: 18px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.forgot-password-screen-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 24px 12px;
  color: #ffffff;
  text-align: center;
}

.forgot-password-screen-back-button {
  position: absolute;
  left: 18px;
  top: 18px;
  border: 1px solid rgba(196, 222, 29, 0.5);
  border-radius: 999px;
  background: transparent;
  color: var(--jedi-green);
  padding: 6px 12px;
  font-weight: 700;
  cursor: pointer;
}

.forgot-password-screen-logo-wrapper {
  width: 76px;
  height: 76px;
  border-radius: 999px;
  background: rgba(196, 222, 29, 0.15);
  border: 1px solid rgba(196, 222, 29, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.forgot-password-screen-logo {
  width: 62px;
  height: 62px;
  object-fit: contain;
}

.forgot-password-screen-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: var(--jedi-main-title);
}

.forgot-password-screen-header p {
  margin: 0;
  max-width: 340px;
  opacity: 0.86;
}

.forgot-password-screen-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 24px 24px;
}

.forgot-password-screen-form label {
  font-size: 0.9rem;
  color: #d6e0e8;
}

.forgot-password-screen-form input {
  width: 100%;
  border: 1px solid rgba(196, 222, 29, 0.28);
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 11px 14px;
  outline: none;
}

.forgot-password-screen-form input:focus {
  border-color: var(--jedi-green);
  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);
}

.forgot-password-screen-error {
  background: rgba(255, 95, 95, 0.16);
  border: 1px solid rgba(255, 95, 95, 0.4);
  color: #ffd7d7;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.forgot-password-screen-success {
  background: rgba(196, 222, 29, 0.18);
  border: 1px solid rgba(196, 222, 29, 0.45);
  color: #eef7b9;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.forgot-password-screen-submit {
  margin-top: 8px;
  border: none;
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--jedi-green);
  color: #20240a;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
}

.forgot-password-screen-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.forgot-password-screen-footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.9rem;
  color: #d6e0e8;
}

.forgot-password-screen-link {
  border: none;
  background: transparent;
  color: var(--jedi-green);
  font-weight: 700;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForgotPasswordScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6GAA6G;EAC7G,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,yCAAyC;EACzC,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".forgot-password-screen-container {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);\n  font-family: 'Arial', sans-serif;\n}\n\n.forgot-password-screen-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.forgot-password-screen-card {\n  position: relative;\n  width: min(520px, 94vw);\n  background: rgba(22, 22, 22, 0.95);\n  border: 1px solid rgba(196, 222, 29, 0.35);\n  border-radius: 18px;\n  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n}\n\n.forgot-password-screen-header {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 24px 24px 12px;\n  color: #ffffff;\n  text-align: center;\n}\n\n.forgot-password-screen-back-button {\n  position: absolute;\n  left: 18px;\n  top: 18px;\n  border: 1px solid rgba(196, 222, 29, 0.5);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--jedi-green);\n  padding: 6px 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.forgot-password-screen-logo-wrapper {\n  width: 76px;\n  height: 76px;\n  border-radius: 999px;\n  background: rgba(196, 222, 29, 0.15);\n  border: 1px solid rgba(196, 222, 29, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.forgot-password-screen-logo {\n  width: 62px;\n  height: 62px;\n  object-fit: contain;\n}\n\n.forgot-password-screen-header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: var(--jedi-main-title);\n}\n\n.forgot-password-screen-header p {\n  margin: 0;\n  max-width: 340px;\n  opacity: 0.86;\n}\n\n.forgot-password-screen-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 24px 24px;\n}\n\n.forgot-password-screen-form label {\n  font-size: 0.9rem;\n  color: #d6e0e8;\n}\n\n.forgot-password-screen-form input {\n  width: 100%;\n  border: 1px solid rgba(196, 222, 29, 0.28);\n  background: #111;\n  color: #fff;\n  border-radius: 12px;\n  padding: 11px 14px;\n  outline: none;\n}\n\n.forgot-password-screen-form input:focus {\n  border-color: var(--jedi-green);\n  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);\n}\n\n.forgot-password-screen-error {\n  background: rgba(255, 95, 95, 0.16);\n  border: 1px solid rgba(255, 95, 95, 0.4);\n  color: #ffd7d7;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 0.9rem;\n}\n\n.forgot-password-screen-success {\n  background: rgba(196, 222, 29, 0.18);\n  border: 1px solid rgba(196, 222, 29, 0.45);\n  color: #eef7b9;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 0.9rem;\n}\n\n.forgot-password-screen-submit {\n  margin-top: 8px;\n  border: none;\n  border-radius: 12px;\n  padding: 14px 16px;\n  background: var(--jedi-green);\n  color: #20240a;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.forgot-password-screen-submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.forgot-password-screen-footer {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 0.9rem;\n  color: #d6e0e8;\n}\n\n.forgot-password-screen-link {\n  border: none;\n  background: transparent;\n  color: var(--jedi-green);\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
